import React from 'react';
import { KYCFieldRow } from './KYCFieldRow';
import { KYCField } from './PersonalInfoTab';
interface BankInfoTabProps {
  fields: KYCField[];
  onFieldChange: (id: string, updates: Partial<KYCField>) => void;
  onSelectAll: (selected: boolean) => void;
}
// Define field metadata with Data Type, Regex, and Explanation
const fieldMetadata: Record<string, {
  fieldType: KYCField['fieldType'];
  regex?: string;
  explanation?: string;
  dropdownOptions?: string[];
}> = {
  bank_type: {
    fieldType: 'dropdown',
    regex: '^[A-Za-z\\s]+$',
    explanation: 'Matches alphabetic characters and spaces, suitable for bank types like "Commercial", "Microfinance", etc.',
    dropdownOptions: ['Commercial', 'Microfinance', 'Islamic', 'Investment']
  },
  bank_name: {
    fieldType: 'text',
    regex: '^[A-Za-z0-9\\s]+$',
    explanation: 'Matches alphanumeric characters and spaces, suitable for bank names.'
  },
  account_number: {
    fieldType: 'text',
    regex: '^\\d{10,20}$',
    explanation: 'Matches numeric account numbers between 10 and 20 digits, typical for bank account numbers.'
  }
};
export function BankInfoTab({
  fields,
  onFieldChange,
  onSelectAll
}: BankInfoTabProps) {
  const allSelected = fields.length > 0 && fields.every(f => f.selected);
  return <div className="space-y-6 py-6 animate-in fade-in slide-in-from-bottom-4 duration-500" data-id="element-352">
      <div className="bg-white rounded-lg border border-gray-200 shadow-sm overflow-hidden" data-id="element-353">
        <div className="bg-gray-50 px-4 py-3 border-b border-gray-200 flex items-center justify-between" data-id="element-354">
          <div className="flex items-center" data-id="element-355">
            <input type="checkbox" checked={allSelected} onChange={e => onSelectAll(e.target.checked)} className="h-4 w-4 text-blue-600 focus:ring-blue-500 border-gray-300 rounded cursor-pointer" data-id="element-356" />
            <span className="ml-4 text-sm font-semibold text-gray-700" data-id="element-357">
              Bank & Wallet Information
            </span>
          </div>
          <div className="flex space-x-12 pr-6" data-id="element-358">
            <span className="text-xs font-semibold text-gray-500 uppercase tracking-wider w-24 text-center" data-id="element-359">
              Configuration
            </span>
          </div>
        </div>

        <div className="divide-y divide-gray-100" data-id="element-360">
          {fields.map(field => {
          const metadata = fieldMetadata[field.id] || {
            fieldType: 'text'
          };
          return <KYCFieldRow key={field.id} label={field.label} isSelected={field.selected} isMandatory={field.mandatory} isOptional={field.optional} fieldType={metadata.fieldType} regex={metadata.regex} explanation={metadata.explanation} dropdownOptions={metadata.dropdownOptions} onToggleSelect={checked => onFieldChange(field.id, {
            selected: checked
          })} onToggleMandatory={checked => onFieldChange(field.id, {
            mandatory: checked,
            optional: checked ? false : field.optional
          })} onToggleOptional={checked => onFieldChange(field.id, {
            optional: checked,
            mandatory: checked ? false : field.mandatory
          })} data-id="element-361" />;
        })}
        </div>
      </div>
    </div>;
}